import { render, staticRenderFns } from "./form-builder.vue?vue&type=template&id=43f532da&scoped=true&"
import script from "./form-builder.vue?vue&type=script&lang=js&"
export * from "./form-builder.vue?vue&type=script&lang=js&"
import style0 from "./form-builder.vue?vue&type=style&index=0&id=43f532da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f532da",
  null
  
)

export default component.exports